/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Add_PlaceholderInputs */

const cs_settings_teams_add_placeholder = /** @type {(inputs: Settings_Teams_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat jméno nebo e-mail…`)
};

const en_settings_teams_add_placeholder = /** @type {(inputs: Settings_Teams_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search name or email…`)
};

/**
* | output |
* | --- |
* | "Search name or email…" |
*
* @param {Settings_Teams_Add_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_add_placeholder = /** @type {((inputs?: Settings_Teams_Add_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Add_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_add_placeholder(inputs)
	return cs_settings_teams_add_placeholder(inputs)
});